import 'quasar/src/css/index.sass'
import '@/css/index.scss'

import { createGtm } from '@gtm-support/vue-gtm'
import * as Sentry from '@sentry/vue'
import { Cookies, Meta, Notify, Quasar } from 'quasar'
import { createApp } from 'vue'

import App from '@/App.vue'
import i18n from '@/i18n'
import router from '@/router'
import pinia from '@/store'

const app = createApp(App)

app
  .use(pinia)
  .use(router)
  .use(i18n)
  .use(Quasar, {
    plugins: { Cookies, Meta, Notify },
  })
  .use(
    createGtm({
      defer: true,
      id: import.meta.env.VITE_GTM_ID,
      vueRouter: router,
    }),
  )

if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
  Sentry.init({
    app,
    attachStacktrace: true,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      //  Sentry.replayIntegration(),
      Sentry.vueIntegration({
        attachErrorHandler: true,
        attachProps: true,
        tracingOptions: {
          trackComponents: true,
        },
      }),
    ],
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_SAMPLE_RATE || '1.0'),
  })
}

app.mount('#app')
